import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import api from "../../utils/apiClient";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import UploadWidget from "../UploadWidget";
import "react-quill/dist/quill.snow.css";
import "../../style/Banner.css";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";

function EditContent() {
  const [title, setTitle] = useState("");
  const [username, setUsername] = useState("");
  const [Dia, setDia] = useState("");
  const [formatDia, setFormatDia] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [images, setImages] = useState([]);
  const [FechaLimiteBoolean, setFechaLimiteBoolean] = useState(false);
  const [storedImages, setStoredImages] = useState([]);
  const [showPreview, setShowPreview] = useState(false); // State for preview modal
  const [previewImage, setPreviewImage] = useState(null);

  const { authToken, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const getuser = async () => {
    const response = await api.get("usuario/getbyToken");
    setUsername(response.data.nombre);
  };

  useEffect(() => {
    const inicio = async () => {
      if (!authToken) {
        navigate("/");
      } else {
        await getuser();
      }
    };
    inicio();
    fetchContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, navigate]);

  const handleUploadSuccess = (image) => {
    setImages([image]);
  };

  const handleDateChange = (event) => {
    const Fecha = new Date(event.target.value);
    const isoString = Fecha.toISOString();
    setFormatDia(isoString);
    setDia(event.target.value);
  };

  const handleTittleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleCheckboxChange = (event) => {
    setFechaLimiteBoolean(event.target.checked);
    if (!event.target.value) {
      setFormatDia(null);
    }
  };

  const deleteImage = async (imageId) => {
    try {
      await api.delete(`anuncios/delete/${imageId}`);
      setStoredImages(storedImages.filter((image) => image._id !== imageId));
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const fetchContent = async (type) => {
    try {
      const response = await api.get("anuncios/Admin");
      setStoredImages(response.data);
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  };

  const saveContent = async () => {
    try {
      const data = {
        title: title,
        Imagen: images[0],
        FechaLimite: formatDia,
      };
      await api.post("anuncios/crearAnuncio", data);
      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 3000);
      fetchContent();

      setTitle("");
      setDia("");
      setFechaLimiteBoolean(false);
      setFormatDia("");
      setImages([]);
    } catch (error) {
      console.error("Error saving content:", error);
    }
  };

  const handlePreview = (image) => {
    setPreviewImage(image);
    setShowPreview(true);
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a">
        <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-c">
          <AdminSidebarDropdown onLogout={handleLogout} />
            <div className="banner-admin-page">
              <div className="ban-header">
                <h2 className="ban-page-title">Banners</h2>
                <p className="ban-page-subtitle">
                  Administra los banners promocionales que aparecen en la página principal
                </p>
              </div>

              <div className="ban-new-card">
                <div className="ban-new-card-header">
                  <h3>Nuevo banner</h3>
                  <p>Sube una imagen y define una fecha de caducidad opcional</p>
                </div>

                <div className="ban-new-card-body">
                  <div className="ban-field-group">
                    <label className="ban-label" htmlFor="tittle">
                      Nombre del banner
                    </label>
                    <input
                      type="text"
                      className="ban-input"
                      placeholder="Ej: Promoción de Abril"
                      id="tittle"
                      value={title}
                      onChange={handleTittleChange}
                    />
                  </div>

                  <div className="ban-upload-field">
                    <label className="ban-label">Imagen</label>
                    <div className="ban-upload-row">
                      <div className="ban-upload-btn-wrap">
                        <UploadWidget onUploadSuccess={handleUploadSuccess} />
                      </div>
                      {images.length > 0 && (
                        <div className="ban-uploaded-preview">
                          <img src={images[0]} alt="preview" />
                          <button
                            className="ban-preview-btn"
                            onClick={() => handlePreview(images[0])}
                          >
                            Vista preliminar
                          </button>
                        </div>
                      )}
                    </div>
                    <p className="ban-size-hint">Tamaño recomendado: 1600 × 800 px</p>
                  </div>

                  <div className="ban-date-row">
                    <div className="ban-field-group ban-field-date">
                      <label className="ban-label" htmlFor="Dia">
                        Fecha límite
                      </label>
                      <input
                        type="date"
                        className="ban-input"
                        name="Dia"
                        id="Dia"
                        value={Dia}
                        onChange={handleDateChange}
                        disabled={FechaLimiteBoolean}
                      />
                    </div>
                    <label className="ban-checkbox-label">
                      <input
                        type="checkbox"
                        checked={FechaLimiteBoolean}
                        onChange={handleCheckboxChange}
                      />
                      <span>Sin fecha límite</span>
                    </label>
                  </div>

                  <button className="ban-save-btn" onClick={saveContent}>
                    Guardar Banner
                  </button>
                </div>
              </div>

              {showSuccessMessage && (
                <div className="ban-success-toast">Banner añadido exitosamente</div>
              )}

              <div className="ban-stored-section">
                <div className="ban-stored-header">
                  <h3>Banners guardados</h3>
                  <span className="ban-count-badge">{storedImages.length}</span>
                </div>

                {storedImages.length === 0 ? (
                  <div className="ban-empty-state">
                    <p>No hay banners guardados todavía</p>
                  </div>
                ) : (
                  <div className="ban-grid">
                    {storedImages.map((image) => (
                      <div key={image._id} className="ban-card">
                        <div className="ban-card-thumb">
                          <img src={image.Imagen} alt={image.title} />
                          <button
                            className="ban-card-preview"
                            onClick={() => handlePreview(image.Imagen)}
                          >
                            Vista preliminar
                          </button>
                        </div>
                        <div className="ban-card-body">
                          <p className="ban-card-title">{image.title}</p>
                          <p className="ban-card-date">
                            {image.FechaLimite
                              ? `Caduca el ${new Date(
                                  image.FechaLimite
                                ).toLocaleDateString()}`
                              : "Sin fecha de caducidad"}
                          </p>
                        </div>
                        <button
                          className="ban-card-del"
                          onClick={() => deleteImage(image._id)}
                        >
                          Eliminar
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPreview && (
        <div className="preview-modal">
          <div className="preview-content">
            <button
              className="close-preview"
              onClick={() => setShowPreview(false)}
            >
              Cerrar
            </button>
            <div className="ads-logos">
              <div className="container">
                <div className="ads-container-1">
                  <div className="ad-1">
                    <img src={previewImage} alt="Preview" className="img-preview" />
                  </div>
                  <div className="ad-2">
                    <img src={previewImage} alt="Preview" className="img-preview" />
                  </div>
                </div>
                <div className="logos-container">
                  <div className="logo">
                    <div className="logo-row">
                      <a href="/stock?marca=Toyota">
                        <img
                          src="images/toyota.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Nissan">
                        <img
                          src="images/nissan.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Jeep">
                        <img
                          src="images/jeep.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Mitsubishi">
                        <img
                          src="images/mitsubishi.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                    </div>
                    <div className="logo-row">
                      <a href="/stock?marca=Dodge">
                        <img
                          src="images/dodge.png"
                          alt=""
                          className="large-logo"
                        />
                      </a>
                      <a href="/stock?marca=Volkswagen">
                        <img
                          src="images/volkswagen.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Bmw">
                        <img
                          src="images/bmw.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                    </div>
                    <div className="logo-row">
                      <a href="/stock?marca=Mazda">
                        <img
                          src="images/mazda.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Mercedes">
                        <img
                          src="images/mercedes.png"
                          alt=""
                          className="large-logo"
                        />
                      </a>
                      <a href="/stock?marca=Kia">
                        <img
                          src="images/kia.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                    </div>
                    <div className="logo-row">
                      <a href="/stock?marca=Acura">
                        <img
                          src="images/acura.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Mercury">
                        <img
                          src="images/mercury.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Hyundai">
                        <img
                          src="images/hyundai.png"
                          alt=""
                          className="large-logo"
                        />
                      </a>
                    </div>
                    <div className="logo-row">
                      <a href="/stock?marca=Gms">
                        <img
                          src="images/gmc.png"
                          alt=""
                          className="large-logo"
                          id="gmc"
                        />
                      </a>
                      <a href="/stock?marca=Audi" id="audi-a">
                        <img
                          src="images/audi.png"
                          alt=""
                          className="large-logo"
                          id="audi"
                        />
                      </a>
                    </div>
                    <div className="logo-row">
                      <a href="/stock?marca=Lexus">
                        <img
                          src="images/lexus.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Ford">
                        <img
                          src="images/ford.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Chevrolet">
                        <img
                          src="images/chevrolet.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                      <a href="/stock?marca=Honda">
                        <img
                          src="images/honda.png"
                          alt=""
                          className="square-logo"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="ads-container">
                  <div className="ad-1"><img src={previewImage} alt="Preview" className="img-preview" /></div>
                  <div className="ad-2"><img src={previewImage} alt="Preview" className="img-preview" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="footer">
      <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default EditContent;
